/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddPersonalCalendarProfile,
  CreateActivityCalendarProfile,
  GetUpdateActivityCalendarProfileParams,
  GetUpdatePersonalCalendarProfileParams,
  UpdateActivityCalendarProfile,
  UpdatePersonalCalendarProfile
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetDefaultUrl = () => {




  return `/api/WebCalendarConfig/GetDefault`
}

export const getDefault = async ( options?: Parameters<typeof customInstance>[1]): Promise<AddPersonalCalendarProfile> => {

  return customInstance<AddPersonalCalendarProfile>(getGetDefaultUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDefaultQueryKey = () => {
    return [
    `/api/WebCalendarConfig/GetDefault`
    ] as const;
    }


export const getGetDefaultQueryOptions = <TData = Awaited<ReturnType<typeof getDefault>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefault>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDefaultQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefault>>> = ({ signal }) => getDefault({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDefault>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDefaultQueryResult = NonNullable<Awaited<ReturnType<typeof getDefault>>>
export type GetDefaultQueryError = ErrorType<unknown>


export function useGetDefault<TData = Awaited<ReturnType<typeof getDefault>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefault>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefault>>,
          TError,
          Awaited<ReturnType<typeof getDefault>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefault<TData = Awaited<ReturnType<typeof getDefault>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefault>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefault>>,
          TError,
          Awaited<ReturnType<typeof getDefault>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefault<TData = Awaited<ReturnType<typeof getDefault>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefault>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDefault<TData = Awaited<ReturnType<typeof getDefault>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefault>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDefaultQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDefaultSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDefault>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDefault>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDefaultQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefault>>> = ({ signal }) => getDefault({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDefault>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetDefaultSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDefault>>>
export type GetDefaultSuspenseQueryError = ErrorType<unknown>


export function useGetDefaultSuspense<TData = Awaited<ReturnType<typeof getDefault>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDefault>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefaultSuspense<TData = Awaited<ReturnType<typeof getDefault>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDefault>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefaultSuspense<TData = Awaited<ReturnType<typeof getDefault>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDefault>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDefaultSuspense<TData = Awaited<ReturnType<typeof getDefault>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDefault>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDefaultSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAddPersonalWebCalendarProfileUrl = () => {




  return `/api/WebCalendarConfig/AddPersonalWebCalendarProfile`
}

export const addPersonalWebCalendarProfile = async (addPersonalCalendarProfile?: AddPersonalCalendarProfile, options?: Parameters<typeof customInstance>[1]): Promise<string> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<string>(getAddPersonalWebCalendarProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addPersonalCalendarProfile)
  }
);}





export const getAddPersonalWebCalendarProfileMutationKey = () => ['addPersonalWebCalendarProfile'] as const;

export const getAddPersonalWebCalendarProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPersonalWebCalendarProfile>>, TError,AddPersonalWebCalendarProfileMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof addPersonalWebCalendarProfile>>, TError,AddPersonalWebCalendarProfileMutationVariables, TContext> => {

const mutationKey = getAddPersonalWebCalendarProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addPersonalWebCalendarProfile>>, AddPersonalWebCalendarProfileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addPersonalWebCalendarProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddPersonalWebCalendarProfileMutationResult = NonNullable<Awaited<ReturnType<typeof addPersonalWebCalendarProfile>>>
    export type AddPersonalWebCalendarProfileMutationBody = BodyType<AddPersonalCalendarProfile> | undefined
    export type AddPersonalWebCalendarProfileMutationError = ErrorType<unknown>
    export type AddPersonalWebCalendarProfileMutationVariables = {data?: BodyType<AddPersonalCalendarProfile>}

    export const useAddPersonalWebCalendarProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPersonalWebCalendarProfile>>, TError,AddPersonalWebCalendarProfileMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addPersonalWebCalendarProfile>>,
        TError,
        AddPersonalWebCalendarProfileMutationVariables,
        TContext
      > => {
      return useMutation(getAddPersonalWebCalendarProfileMutationOptions(options), queryClient);
    }
    export const getDeletePersonalWebCalendarProfileUrl = () => {




  return `/api/WebCalendarConfig/DeletePersonalWebCalendarProfile`
}

export const deletePersonalWebCalendarProfile = async (deletePersonalWebCalendarProfileBody?: number, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getDeletePersonalWebCalendarProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deletePersonalWebCalendarProfileBody)
  }
);}





export const getDeletePersonalWebCalendarProfileMutationKey = () => ['deletePersonalWebCalendarProfile'] as const;

export const getDeletePersonalWebCalendarProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePersonalWebCalendarProfile>>, TError,DeletePersonalWebCalendarProfileMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePersonalWebCalendarProfile>>, TError,DeletePersonalWebCalendarProfileMutationVariables, TContext> => {

const mutationKey = getDeletePersonalWebCalendarProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePersonalWebCalendarProfile>>, DeletePersonalWebCalendarProfileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  deletePersonalWebCalendarProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePersonalWebCalendarProfileMutationResult = NonNullable<Awaited<ReturnType<typeof deletePersonalWebCalendarProfile>>>
    export type DeletePersonalWebCalendarProfileMutationBody = BodyType<number> | undefined
    export type DeletePersonalWebCalendarProfileMutationError = ErrorType<unknown>
    export type DeletePersonalWebCalendarProfileMutationVariables = {data?: BodyType<number>}

    export const useDeletePersonalWebCalendarProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePersonalWebCalendarProfile>>, TError,DeletePersonalWebCalendarProfileMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePersonalWebCalendarProfile>>,
        TError,
        DeletePersonalWebCalendarProfileMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePersonalWebCalendarProfileMutationOptions(options), queryClient);
    }
    export const getUpdatePersonalWebCalendarProfileUrl = () => {




  return `/api/WebCalendarConfig/UpdatePersonalWebCalendarProfile`
}

export const updatePersonalWebCalendarProfile = async (updatePersonalCalendarProfile?: UpdatePersonalCalendarProfile, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdatePersonalWebCalendarProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePersonalCalendarProfile)
  }
);}





export const getUpdatePersonalWebCalendarProfileMutationKey = () => ['updatePersonalWebCalendarProfile'] as const;

export const getUpdatePersonalWebCalendarProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePersonalWebCalendarProfile>>, TError,UpdatePersonalWebCalendarProfileMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePersonalWebCalendarProfile>>, TError,UpdatePersonalWebCalendarProfileMutationVariables, TContext> => {

const mutationKey = getUpdatePersonalWebCalendarProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePersonalWebCalendarProfile>>, UpdatePersonalWebCalendarProfileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updatePersonalWebCalendarProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePersonalWebCalendarProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updatePersonalWebCalendarProfile>>>
    export type UpdatePersonalWebCalendarProfileMutationBody = BodyType<UpdatePersonalCalendarProfile> | undefined
    export type UpdatePersonalWebCalendarProfileMutationError = ErrorType<unknown>
    export type UpdatePersonalWebCalendarProfileMutationVariables = {data?: BodyType<UpdatePersonalCalendarProfile>}

    export const useUpdatePersonalWebCalendarProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePersonalWebCalendarProfile>>, TError,UpdatePersonalWebCalendarProfileMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePersonalWebCalendarProfile>>,
        TError,
        UpdatePersonalWebCalendarProfileMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePersonalWebCalendarProfileMutationOptions(options), queryClient);
    }
    export const getCreateActivityWebCalendarProfileUrl = () => {




  return `/api/WebCalendarConfig/CreateActivityWebCalendarProfile`
}

export const createActivityWebCalendarProfile = async (createActivityCalendarProfile?: CreateActivityCalendarProfile, options?: Parameters<typeof customInstance>[1]): Promise<string> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<string>(getCreateActivityWebCalendarProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createActivityCalendarProfile)
  }
);}





export const getCreateActivityWebCalendarProfileMutationKey = () => ['createActivityWebCalendarProfile'] as const;

export const getCreateActivityWebCalendarProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createActivityWebCalendarProfile>>, TError,CreateActivityWebCalendarProfileMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createActivityWebCalendarProfile>>, TError,CreateActivityWebCalendarProfileMutationVariables, TContext> => {

const mutationKey = getCreateActivityWebCalendarProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createActivityWebCalendarProfile>>, CreateActivityWebCalendarProfileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createActivityWebCalendarProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateActivityWebCalendarProfileMutationResult = NonNullable<Awaited<ReturnType<typeof createActivityWebCalendarProfile>>>
    export type CreateActivityWebCalendarProfileMutationBody = BodyType<CreateActivityCalendarProfile> | undefined
    export type CreateActivityWebCalendarProfileMutationError = ErrorType<unknown>
    export type CreateActivityWebCalendarProfileMutationVariables = {data?: BodyType<CreateActivityCalendarProfile>}

    export const useCreateActivityWebCalendarProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createActivityWebCalendarProfile>>, TError,CreateActivityWebCalendarProfileMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createActivityWebCalendarProfile>>,
        TError,
        CreateActivityWebCalendarProfileMutationVariables,
        TContext
      > => {
      return useMutation(getCreateActivityWebCalendarProfileMutationOptions(options), queryClient);
    }
    export const getUpdateActivityWebCalendarProfileUrl = () => {




  return `/api/WebCalendarConfig/UpdateActivityWebCalendarProfile`
}

export const updateActivityWebCalendarProfile = async (updateActivityCalendarProfile?: UpdateActivityCalendarProfile, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdateActivityWebCalendarProfileUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateActivityCalendarProfile)
  }
);}





export const getUpdateActivityWebCalendarProfileMutationKey = () => ['updateActivityWebCalendarProfile'] as const;

export const getUpdateActivityWebCalendarProfileMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActivityWebCalendarProfile>>, TError,UpdateActivityWebCalendarProfileMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateActivityWebCalendarProfile>>, TError,UpdateActivityWebCalendarProfileMutationVariables, TContext> => {

const mutationKey = getUpdateActivityWebCalendarProfileMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateActivityWebCalendarProfile>>, UpdateActivityWebCalendarProfileMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updateActivityWebCalendarProfile(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateActivityWebCalendarProfileMutationResult = NonNullable<Awaited<ReturnType<typeof updateActivityWebCalendarProfile>>>
    export type UpdateActivityWebCalendarProfileMutationBody = BodyType<UpdateActivityCalendarProfile> | undefined
    export type UpdateActivityWebCalendarProfileMutationError = ErrorType<unknown>
    export type UpdateActivityWebCalendarProfileMutationVariables = {data?: BodyType<UpdateActivityCalendarProfile>}

    export const useUpdateActivityWebCalendarProfile = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateActivityWebCalendarProfile>>, TError,UpdateActivityWebCalendarProfileMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateActivityWebCalendarProfile>>,
        TError,
        UpdateActivityWebCalendarProfileMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateActivityWebCalendarProfileMutationOptions(options), queryClient);
    }
    export const getGetUpdateActivityCalendarProfileUrl = (params: GetUpdateActivityCalendarProfileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/WebCalendarConfig/GetUpdateActivityCalendarProfile?${stringifiedParams}` : `/api/WebCalendarConfig/GetUpdateActivityCalendarProfile`
}

export const getUpdateActivityCalendarProfile = async (params: GetUpdateActivityCalendarProfileParams, options?: Parameters<typeof customInstance>[1]): Promise<UpdateActivityCalendarProfile> => {

  return customInstance<UpdateActivityCalendarProfile>(getGetUpdateActivityCalendarProfileUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUpdateActivityCalendarProfileQueryKey = (params?: GetUpdateActivityCalendarProfileParams,) => {
    return [
    `/api/WebCalendarConfig/GetUpdateActivityCalendarProfile`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUpdateActivityCalendarProfileQueryOptions = <TData = Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError = ErrorType<unknown>>(params: GetUpdateActivityCalendarProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpdateActivityCalendarProfileQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>> = ({ signal }) => getUpdateActivityCalendarProfile(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUpdateActivityCalendarProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>>
export type GetUpdateActivityCalendarProfileQueryError = ErrorType<unknown>


export function useGetUpdateActivityCalendarProfile<TData = Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdateActivityCalendarProfileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>,
          TError,
          Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdateActivityCalendarProfile<TData = Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdateActivityCalendarProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>,
          TError,
          Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdateActivityCalendarProfile<TData = Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdateActivityCalendarProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUpdateActivityCalendarProfile<TData = Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdateActivityCalendarProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUpdateActivityCalendarProfileQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUpdateActivityCalendarProfileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError = ErrorType<unknown>>(params: GetUpdateActivityCalendarProfileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpdateActivityCalendarProfileQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>> = ({ signal }) => getUpdateActivityCalendarProfile(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUpdateActivityCalendarProfileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>>
export type GetUpdateActivityCalendarProfileSuspenseQueryError = ErrorType<unknown>


export function useGetUpdateActivityCalendarProfileSuspense<TData = Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdateActivityCalendarProfileParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdateActivityCalendarProfileSuspense<TData = Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdateActivityCalendarProfileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdateActivityCalendarProfileSuspense<TData = Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdateActivityCalendarProfileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUpdateActivityCalendarProfileSuspense<TData = Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdateActivityCalendarProfileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdateActivityCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUpdateActivityCalendarProfileSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUpdatePersonalCalendarProfileUrl = (params: GetUpdatePersonalCalendarProfileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/WebCalendarConfig/GetUpdatePersonalCalendarProfile?${stringifiedParams}` : `/api/WebCalendarConfig/GetUpdatePersonalCalendarProfile`
}

export const getUpdatePersonalCalendarProfile = async (params: GetUpdatePersonalCalendarProfileParams, options?: Parameters<typeof customInstance>[1]): Promise<UpdatePersonalCalendarProfile> => {

  return customInstance<UpdatePersonalCalendarProfile>(getGetUpdatePersonalCalendarProfileUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUpdatePersonalCalendarProfileQueryKey = (params?: GetUpdatePersonalCalendarProfileParams,) => {
    return [
    `/api/WebCalendarConfig/GetUpdatePersonalCalendarProfile`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUpdatePersonalCalendarProfileQueryOptions = <TData = Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError = ErrorType<unknown>>(params: GetUpdatePersonalCalendarProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpdatePersonalCalendarProfileQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>> = ({ signal }) => getUpdatePersonalCalendarProfile(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUpdatePersonalCalendarProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>>
export type GetUpdatePersonalCalendarProfileQueryError = ErrorType<unknown>


export function useGetUpdatePersonalCalendarProfile<TData = Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdatePersonalCalendarProfileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>,
          TError,
          Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdatePersonalCalendarProfile<TData = Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdatePersonalCalendarProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>,
          TError,
          Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdatePersonalCalendarProfile<TData = Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdatePersonalCalendarProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUpdatePersonalCalendarProfile<TData = Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdatePersonalCalendarProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUpdatePersonalCalendarProfileQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUpdatePersonalCalendarProfileSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError = ErrorType<unknown>>(params: GetUpdatePersonalCalendarProfileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpdatePersonalCalendarProfileQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>> = ({ signal }) => getUpdatePersonalCalendarProfile(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUpdatePersonalCalendarProfileSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>>
export type GetUpdatePersonalCalendarProfileSuspenseQueryError = ErrorType<unknown>


export function useGetUpdatePersonalCalendarProfileSuspense<TData = Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdatePersonalCalendarProfileParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdatePersonalCalendarProfileSuspense<TData = Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdatePersonalCalendarProfileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdatePersonalCalendarProfileSuspense<TData = Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdatePersonalCalendarProfileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUpdatePersonalCalendarProfileSuspense<TData = Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError = ErrorType<unknown>>(
 params: GetUpdatePersonalCalendarProfileParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonalCalendarProfile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUpdatePersonalCalendarProfileSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateWebcalendarSubscriptionUrl = () => {




  return `/api/WebCalendarConfig/CreateWebcalendarSubscription`
}

export const createWebcalendarSubscription = async (createWebcalendarSubscriptionBody: number, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getCreateWebcalendarSubscriptionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createWebcalendarSubscriptionBody)
  }
);}





export const getCreateWebcalendarSubscriptionMutationKey = () => ['createWebcalendarSubscription'] as const;

export const getCreateWebcalendarSubscriptionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWebcalendarSubscription>>, TError,CreateWebcalendarSubscriptionMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createWebcalendarSubscription>>, TError,CreateWebcalendarSubscriptionMutationVariables, TContext> => {

const mutationKey = getCreateWebcalendarSubscriptionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWebcalendarSubscription>>, CreateWebcalendarSubscriptionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createWebcalendarSubscription(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateWebcalendarSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof createWebcalendarSubscription>>>
    export type CreateWebcalendarSubscriptionMutationBody = BodyType<number>
    export type CreateWebcalendarSubscriptionMutationError = ErrorType<unknown>
    export type CreateWebcalendarSubscriptionMutationVariables = {data: BodyType<number>}

    export const useCreateWebcalendarSubscription = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWebcalendarSubscription>>, TError,CreateWebcalendarSubscriptionMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWebcalendarSubscription>>,
        TError,
        CreateWebcalendarSubscriptionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateWebcalendarSubscriptionMutationOptions(options), queryClient);
    }
    export const getCanAddPersonalCalenderUrl = () => {




  return `/api/WebCalendarConfig/CanAddPersonalCalender`
}

export const canAddPersonalCalender = async ( options?: Parameters<typeof customInstance>[1]): Promise<boolean> => {

  return customInstance<boolean>(getCanAddPersonalCalenderUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCanAddPersonalCalenderQueryKey = () => {
    return [
    `/api/WebCalendarConfig/CanAddPersonalCalender`
    ] as const;
    }


export const getCanAddPersonalCalenderQueryOptions = <TData = Awaited<ReturnType<typeof canAddPersonalCalender>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCanAddPersonalCalenderQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof canAddPersonalCalender>>> = ({ signal }) => canAddPersonalCalender({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof canAddPersonalCalender>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CanAddPersonalCalenderQueryResult = NonNullable<Awaited<ReturnType<typeof canAddPersonalCalender>>>
export type CanAddPersonalCalenderQueryError = ErrorType<unknown>


export function useCanAddPersonalCalender<TData = Awaited<ReturnType<typeof canAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof canAddPersonalCalender>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof canAddPersonalCalender>>,
          TError,
          Awaited<ReturnType<typeof canAddPersonalCalender>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCanAddPersonalCalender<TData = Awaited<ReturnType<typeof canAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canAddPersonalCalender>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof canAddPersonalCalender>>,
          TError,
          Awaited<ReturnType<typeof canAddPersonalCalender>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCanAddPersonalCalender<TData = Awaited<ReturnType<typeof canAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCanAddPersonalCalender<TData = Awaited<ReturnType<typeof canAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCanAddPersonalCalenderQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCanAddPersonalCalenderSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof canAddPersonalCalender>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCanAddPersonalCalenderQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof canAddPersonalCalender>>> = ({ signal }) => canAddPersonalCalender({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof canAddPersonalCalender>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type CanAddPersonalCalenderSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof canAddPersonalCalender>>>
export type CanAddPersonalCalenderSuspenseQueryError = ErrorType<unknown>


export function useCanAddPersonalCalenderSuspense<TData = Awaited<ReturnType<typeof canAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCanAddPersonalCalenderSuspense<TData = Awaited<ReturnType<typeof canAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCanAddPersonalCalenderSuspense<TData = Awaited<ReturnType<typeof canAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCanAddPersonalCalenderSuspense<TData = Awaited<ReturnType<typeof canAddPersonalCalender>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof canAddPersonalCalender>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCanAddPersonalCalenderSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






